module.exports = __webpack_public_path__ + "img/inbox-logo.a92a5e1e.svg";